<template>
    <Modal :title="titleIntern" :show="showModal" @close="onClose">
        <form @submit.prevent="onSubmit">
            <div class="tab-content">
                <ul class="nav nav-pills mb-3" role="tablist">
                    <li  class="nav-item">
                        <a :class="['nav-link', { 'text-danger': errorsGeneral && !isActiveTab('pills-content'), 'active': isActiveTab('pills-content') }]"  aria-selected="true" id="pills-content-tab" aria-controls="pills-content" role="tab" @click="handleTabClick('pills-content')">General</a>
                    </li>

                    <li class="nav-item">
                        <a :class="['nav-link', { 'text-danger': errorsFile && !isActiveTab('pills-file'), 'active': isActiveTab('pills-file') }]" aria-selected="false" id="pills-file-tab" aria-controls="pills-file" role="tab" @click="handleTabClick('pills-file')">File</a>
                    </li>

                    <li class="nav-item" v-if="!detail">
                        <a :class="['nav-link', { 'text-danger': errorsBrand && !isActiveTab('pills-brand'), 'active': isActiveTab('pills-brand') }]" aria-selected="false" id="pills-brand-tab" aria-controls="pills-brand" role="tab" @click="handleTabClick('pills-brand')">Brand</a>
                    </li>
                </ul>

                <div class="tab-pane fade" :class="{ 'active show': isActiveTab('pills-content') }" id="pills-content" role="tabpanel" aria-labelledby="pills-content-tab">
                    <select-input label="Country" :error="getFirstItem(errors.country)" v-model="form.country">
                        <option value="0">Select</option>
                        <option v-for="(option, index) in countries" :key="index" :value="option.id">
                            {{ option.name }}
                        </option>
                    </select-input>
                    <text-input label="Name" name="name" :error="getFirstItem(errors.name)" v-model="form.name" ref="textInputRef"/>
                    <select-input label="Type file" :error="getFirstItem(errors.type_file)" v-model="form.type_file" @input="handleChangeLabelNumber()" :disabled="detail ? true : false">
                        <option value="0" v-if="! detail">Select</option>
                        <option v-for="(option, index) in typeFiles" :key="index" :value="option.id">
                            {{ option.name }}
                        </option>
                    </select-input>
                    <text-input  v-if="labelNumber" :label="labelNumber" name="number" :error="getFirstItem(errors.number)" v-model="form.number" />
                </div>

                <div class="tab-pane fade" :class="{ 'active show': isActiveTab('pills-file') }" id="pills-file" role="tabpanel" aria-labelledby="pills-file-tab">
                    <radio-input v-if="!detail" label="Type" name="type" :items="types" :error="getFirstItem(errors.type)" v-model="form.type" />
                    <text-input v-if="showUrlInput" label="Url" name="external_file" :error="getFirstItem(errors.external_file)" v-model="form.external_file" />
                    <upload-file v-else :is-local="isLocal" :upload-error="getFirstItem(errors.upload)" :document="document" @upload="handleUpload" />
                </div>

                <div class="tab-pane fade" :class="{ 'active show': isActiveTab('pills-brand') }"  id="pills-brand" role="tabpanel" aria-labelledby="pills-brand-tab" v-if="!detail">
                    <label>Brands</label>
                    <br>
                    <div>
                        <div class="form-check vertical" v-for="brand in brandOptions" :key="brand.id">
                            <input :id="'option-' + brand.id" class="form-check-input" type="checkbox" :value="brand.id" v-model="form.brands"/>
                            <label :for="'option-' + brand.id" class="form-check-label">
                                {{ brand.name }}
                            </label>
                        </div>
                        <div v-if="brandOptions.length == 0">
                            <label>{{ this.forElseMessage }}</label>
                        </div>
                        <div class="invalid-feedback d-block" v-if="getFirstItem(errors.brands)">
                            {{ getFirstItem(errors.brands) }}
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <template v-slot:footer>
            <button class="btn btn-primary" ref="submitRef" @click.prevent="onSubmit">Submit</button>
            <button class="btn btn-link" @click.prevent="onClose">Close</button>
        </template>
    </Modal>
</template>

<script>
import Modal from "../Modal";
import RadioInput from '../Inputs/RadioInput.vue';
import TextInput from '../Inputs/TextInput.vue';
import SelectInput from '../Inputs/SelectInput.vue';
import GetFirstItem from '../../mixins/GetFirstItem.js';
import UploadFile from './UploadFile.vue';
import { EventBus } from '../../event-bus.js';

export default {
    name: "UploadModal",
    props: {
        title: { type:String, required: true },
        isLocal: { type:Boolean, required:true},
        attachmentType: { type:String, default:null, required:false },
        attachmentId: { type:Number, default:null, required:false },
        attachmentBrand: { type:Number, default:null, required: false},
        detail: { type:Boolean, default:false, required: false},
        brandOptions: { type:Array, default:() => [], required: false},
        forElseMessage: { type: String, default: 'No items available', required: false },
        typeFiles: { type:Array, required: true},
        typeNumbers: { type:Object, required: true},
        countries: { type:Array, required: true},
        agreementCountry: { type:Number, default:null, required:false},
        searched: { type:String, default:'', required:false},
        selectedTypeFiles:  { type:Array, default:() => [], required:false},
        selectedBrands: { type:Array, default:() => [], required:false},
        selectedCountries: { type:Array, default:() => [], required:false},
    },
    components: {
        Modal,
        RadioInput,
        TextInput,
        SelectInput,
        UploadFile,
    },
    mixins: [GetFirstItem],
    computed: {
        showUrlInput() {
            return this.form.type !== 'file';
        },
        errorsGeneral() {
            return this.getFirstItem(this.errors.country) || this.getFirstItem(this.errors.name) || this.getFirstItem(this.errors.type_file) || this.getFirstItem(this.errors.number);
        },
        errorsFile() {
            return this.getFirstItem(this.errors.type) || this.getFirstItem(this.errors.external_file) || this.getFirstItem(this.errors.upload);
        },
        errorsBrand() {
            return this.getFirstItem(this.errors.brands);
        },
    },
    data() {
        return {
            titleIntern: this.$props.title,
            types: [
                {
                    'value': 'file',
                    'label': 'File',
                },
                {
                    'value': 'url',
                    'label': 'Url',
                },
            ],
            showModal: false,
            form: {
                country: 0,
                name: null,
                type: 'file',
                external_file: null,
                type_file: 0,
                number: null,
                brands: [],
            },
            document: {},
            errors: {},
            upload: {},
            defaultBrand: this.attachmentBrand,
            labelNumber: null,
            activeTab: 'pills-content',
        };
    },
    watch: {
        document(newValue, oldValue) {
            this.form.country = newValue?.country_value ?? 0;
            this.form.name = newValue?.name;
            this.form.type = newValue?.type ?? 'file';
            this.form.external_file =  newValue?.external_file;
            this.form.type_file =  newValue?.type_file ?? 0;
            this.form.number =  newValue?.number;
            this.form.brands = newValue?.brands ?? [];
            this.handleChangeLabelNumber();
        },
    },
    created() {
        EventBus.$on('openUploadModal', (document, title) => {
            if(document) {
                this.document = document;
            }

            if(title) { //edit
                this.titleIntern = title;
            } else { //upload
                if(this.defaultBrand) {
                    this.form.brands = [];
                    this.form.brands.push(this.defaultBrand);
                }

            }
            if(this.detail) {
                this.form.type_file = 10;
                this.handleChangeLabelNumber();
            }

            if(this.agreementCountry) {
                this.form.country = this.agreementCountry;
            }

            this.showModal = true;

            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$refs.textInputRef.$refs.input.focus();
                });
            });
        });
        EventBus.$on('brand-changed-upload-modal', (name, value) => {
            this.changeDefaultBrand(value);
        });
        EventBus.$on('brand-added-upload-modal', (name, value) => {
            this.changeDefaultBrand(value);
        });
    },
    beforeDestroy() {
        EventBus.$off('openUploadModal');
        EventBus.$off('brand-changed-upload-modal');
        EventBus.$off('brand-added-upload-modal');
    },
    methods: {
        handleTabClick(tabId) {
            this.activeTab = tabId;
        },
        isActiveTab(tabId) {
            return this.activeTab === tabId;
        },
        handleChangeLabelNumber() {
            this.labelNumber = this.typeNumbers[this.form.type_file] ?? null;
        },
        changeDefaultBrand(value) {
            if(this.detail) {
                this.form.brands = [];
                this.defaultBrand = null;

                if(value != 0) {
                    this.form.brands.push(value);
                    this.defaultBrand = value;
                }
            }
        },
        handleUpload(values) {
            this.upload = values;
        },
        resetValues() {
            this.titleIntern = this.$props.title;
            this.form = {
                country: 0,
                name: null,
                type: 'file',
                external_file: null,
                type_file: 0,
                number: null,
                brands: [],
            };
            this.labelNumber = null;
            this.document = {};
            this.errors = {};
            this.upload = {};
            this.activeTab ='pills-content';
        },
        reloadPageWithDocumentId(name) {
            const currentPath = window.location.pathname;
            const origin = window.location.origin;
            const url = new URL(origin + currentPath);

            url.searchParams.set('name', name);
            if (Object.keys(this.document).length === 0) {
                url.searchParams.set('status', 'created');
            }

            url.searchParams.set('search', this.searched);
            this.selectedCountries.forEach(value => url.searchParams.append('select_country[]', value));
            this.selectedTypeFiles.forEach(value => url.searchParams.append('select_type_file[]', value));
            this.selectedBrands.forEach(value => url.searchParams.append('select_brand[]', value));

            const href = url.toString();

            this.resetValues();

            window.location.href = href;
        },
        onSubmit() {
            const params = {
                id: this.document?.id || null,
                type: this.form.type || null,
                country: this.form.country || null,
                name: this.form.name || null,
                brands: this.form.brands,
                type_file: this.form.type_file || null,
                number: this.form.type_file ? this.form.number || null : null,
                filename: (this.form.type == 'file') ? this.upload?.filename || this.document?.filename || null : null,
                key: (this.form.type == 'file') ? this.upload?.key || this.document?.key || null : null,
                size: (this.form.type == 'file') ? this.upload?.size || this.document?.size || null : null,
                content_type: (this.form.type == 'file') ? this.upload?.content_type || this.document?.content_type || null : null,
                external_file: this.form.external_file || null,
                detail: this.detail,
            }

            if(this.attachmentType && this.attachmentId) {
                params.attachment_type = this.attachmentType;
                params.attachment_id = this.attachmentId;
            }

            axios.post('/api/save-document', params).then((response) =>  {
                if(this.detail) {
                    EventBus.$emit('detailFileChanged', response.data.document);
                } else {
                    this.reloadPageWithDocumentId(response.data?.document?.name || '');
                }
                this.onClose();
            }).catch(error => {
                if (error.response && error.response.status == 422) {
                    this.errors = error.response.data.errors;
                }
            });
        },
        onClose() {
            this.resetValues();
            this.showModal = false;
        },
    }
}
</script>